import React from 'react';
export function Footer() {
  return <footer className="bg-cream py-16" data-id="element-93" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-94" data-mp="3gf94uw0pu68y">
        <p className="font-display text-2xl text-mint-700" data-id="element-95" data-mp="3ggtxuh7dth4p">
          Catering para Emprender
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-ink-soft" data-id="element-96" data-mp="32pp764lzrz6i">
          Recetas y menús para vender bocadillos, botanas y charolas por encargo, desde tu cocina de casa.
        </p>

        <div className="mt-10 border-t border-cream-line pt-8 text-sm text-ink-muted" data-id="element-97" data-mp="3ucxok0j1r7cf">
          <p data-id="element-98" data-mp="37xx4ku5y8k4">© Naturia Cocina. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-99" data-mp="3lf5bl30ssbs7">
            <a href="mailto:soporte@naturiasalud.com" className="text-mint-700 underline-offset-4 hover:underline" data-id="element-100" data-mp="3le2icog05x94">
              soporte@naturiasalud.com
            </a>
          </p>
          <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed" data-id="element-101" data-mp="29ydxq3q81abh">
            Los precios están expresados en pesos mexicanos (MXN). Si compras desde otro país, el cobro se convierte a tu moneda al
            momento del pago. Los precios de los menús y los ejemplos de costeo
            son referencias ilustrativas y no garantizan ventas ni ingresos. La
            información sobre impuestos y trámites es orientativa y no sustituye
            la asesoría de un contador ni de la autoridad sanitaria de tu estado.
          </p>
        </div>
      </div>
    </footer>;
}